import Vue from 'vue'
import Vuex from 'vuex'
import searchFilter from './modules/searchFilter'
// import createLogger from '@/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    searchFilter
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js